import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Email } from './../../../../assets/smtp.js';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-join-us',
  templateUrl: './join-us.component.html',
  styleUrls: ['./join-us.component.scss']
})
export class JoinUsComponent implements OnInit {

  firstFormGroup: FormGroup;
  text: string = '';
  fileContent: string;
  fileName: string;

  constructor(private modalService: NgbModal, private toastr: ToastrService, private _formBuilder: FormBuilder) { }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({
      nameCtrl: ['', [Validators.required]],
      emailCtrl: ['', [Validators.required, Validators.email]],
      aboutCtrl: ['', [Validators.maxLength(500)]],
      fileName: ['', [Validators.required]],
      fileContent: ['', [Validators.required]],
    });
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true });
  }

  onFileSelect(event) {
    if (event.target.files && event.target.files[0]) {
      let chosenFileName = event.target.files[0].name as string;
      let fileName = "Click here to choose another file";
      this.firstFormGroup.controls["fileName"].setValue(fileName);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.firstFormGroup.controls["fileContent"].setValue(reader.result as string);
        if (this.firstFormGroup.controls["fileName"].value != '' && this.firstFormGroup.controls["fileContent"].value != '') {
          this.toastr.success(`"${chosenFileName}" file was successfully uploaded!`, 'Uploading File', {
            timeOut: 6000,
            progressBar: true,
          })
          let button = document.getElementById('choose-cv');
          button.innerHTML = `<i class='fa fa-check-circle m-r-10'></i>${fileName}`;
        } else {
          this.toastr.error("File shouldn't be empty or undefined!", 'Uploading File', {
            timeOut: 5000,
            progressBar: true,
          });
        }
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  onSubmit(f: FormGroup) {
    Email.send({
      Host: 'smtp.elasticemail.com',
      Username: 'owner@customsolutions.info',
      Password: '3E829C5D585B36117614FD683054A24B3FC5',
      To: 'info@customsolutions.info',
      From: 'owner@customsolutions.info',
      Subject: 'SV from Candidate',
      Body: `
    <b>Name: </b>${this.firstFormGroup.controls["nameCtrl"].value} <br/><b>Email: </b>${this.firstFormGroup.controls["emailCtrl"].value}<br/> 
    <b>Message: </b>${this.firstFormGroup.controls["aboutCtrl"].value}<br/>
    <b>~End of Message.~</b>`,
      Attachments: [
        {
          name: this.firstFormGroup.controls["fileName"].value,
          data: this.firstFormGroup.controls["fileContent"].value
        }]
    }).then(message => {
      let answerFromSmtp = message as string;
      if (answerFromSmtp.toLocaleLowerCase() == 'ok') {
        this.toastr.success('Email was sent successfully!', 'Sending Email', {
          timeOut: 4000,
          progressBar: true,
        });
      }
      else {
        this.toastr.error(answerFromSmtp, 'Sending Email', {
          timeOut: 5000,
          progressBar: true,
        });
      }
      f.reset();
      this.modalService.dismissAll()
    });
  }

  closeModalWindow() {
    this.modalService.dismissAll();
    this.firstFormGroup.reset();
  }
}
